import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import deepcopy from 'deepcopy' 
import { connect } from 'react-redux'
import AddonForm from '../helpers/AddonForm';

class EditPanel extends Component {
    render(){

        const { addon, onSaveSettings, toggleType, rowSettings, colSettings, uniqueId } = this.props;
            var settings, addonData, addonName;
            
            if(toggleType == 'addon' || toggleType == 'inner_addon') {
                addonData = deepcopy(addon)
                addonName = addonData.settings.addonName
                settings = addonData.settings.formData
                settings.instFormId = uniqueId
            } else if(toggleType == 'row' || toggleType == 'inner_row') {
                rowSettings.instFormId = uniqueId;
                settings = rowSettings
            } else if(toggleType == 'column' || toggleType == 'inner_column') {
                colSettings.instFormId = uniqueId;
                settings = colSettings
            }

        return(
            <div key={ uniqueId } className="sp-pagebuilder-edit-panel">
                <AddonForm
                    addon={addon}
                    uniqueId={uniqueId}
                    addonName={addonName}
                    settings={settings}
                    onSaveSettings={onSaveSettings}
                    toggleType={toggleType}
                />
            </div>
        )
    }
}

export default EditPanel;


// WEBPACK FOOTER //
// ./src/components/EditPanel.js